import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";

/**
 * Returns auth state and actions. Uses AuthProvider context so session is fetched
 * at most once per app load; all consumers share the same user and no duplicate
 * /auth/session requests are made.
 */
export function useAuth() {
  const ctx = useContext(AuthContext);
  if (ctx === undefined) {
    throw new Error("useAuth must be used within AuthProvider (e.g. inside LayoutDefault)");
  }
  return ctx;
}